import RegisterContainer from "./Register.container";

export default RegisterContainer;
